import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { MotionLazy } from "./components/animate/motion-lazy";
import { RouteLoadingProgress } from "./components/loading";
import Toast from "./components/toast";
import VersionUpdateNotifier from "./components/version-update-notifier";
import { GLOBAL_CONFIG } from "./global-config";
import { AntdAdapter } from "./theme/adapter/antd.adapter";
import { ThemeProvider } from "./theme/theme-provider";
import "./test-environment.css";

const watermarkItems = Array.from({ length: 48 }, (_, index) => `watermark-${index + 1}`);

if (import.meta.env.DEV) {
  import("react-scan").then(({ scan }) => {
    scan({
      enabled: false,
      showToolbar: true,
      log: false,
      animationSpeed: "fast",
    });
  });
}

function App({ children }: { children: React.ReactNode }) {
  return (
    <HelmetProvider>
      <QueryClientProvider client={new QueryClient()}>
        <ThemeProvider adapters={[AntdAdapter]}>
          <Helmet>
            <title>{GLOBAL_CONFIG.isTestEnvironment ? `[TEST] ${GLOBAL_CONFIG.appName}` : GLOBAL_CONFIG.appName}</title>
            <link rel="icon" type="image/x-icon" href="/favicon.ico" />
          </Helmet>
          <div className={GLOBAL_CONFIG.isTestEnvironment ? "test-environment" : undefined}>
            {GLOBAL_CONFIG.isTestEnvironment && (
              <>
                <output className="test-environment-banner">
                  <span className="test-environment-badge">TEST</span>
                  <span>测试环境 · 请确认当前环境后再操作</span>
                </output>
                <div className="test-environment-watermark" aria-hidden="true">
                  {watermarkItems.map((item) => (
                    <span key={item}>TEST ENVIRONMENT</span>
                  ))}
                </div>
              </>
            )}
            <Toast />
            <VersionUpdateNotifier />
            <RouteLoadingProgress />
            <MotionLazy>{children}</MotionLazy>
          </div>
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
